import Link from "next/link";
import { formatMediaType } from "@/lib/books-films";
import type { BookFilm } from "@/types";

interface BookFilmCardProps {
  item: BookFilm;
}

const mediaTypeBadgeColors: Record<string, string> = {
  book: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  film: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
  "tv-show": "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  documentary: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
};

export function BookFilmCard({ item }: BookFilmCardProps) {
  return (
    <div className="rounded-lg border border-gray-200 p-5 transition-colors hover:border-primary dark:border-gray-700 dark:hover:border-primary-light">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <Link
            href={`/books-films/${item.slug}`}
            className="font-semibold text-gray-900 hover:text-primary dark:text-gray-100"
          >
            {item.title}
          </Link>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {item.creator} &middot; {item.year}
          </p>
        </div>
        <span
          className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium ${mediaTypeBadgeColors[item.mediaType] || "bg-gray-100 text-gray-800"}`}
        >
          {formatMediaType(item.mediaType)}
        </span>
      </div>

      <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
        {item.description}
      </p>

      {item.rowingConnection && (
        <p className="mt-2 text-xs text-gray-500 italic dark:text-gray-500">
          {item.rowingConnection}
        </p>
      )}

      <div className="mt-3 flex items-center gap-3">
        <Link
          href={`/books-films/${item.slug}`}
          className="text-sm font-medium text-primary hover:underline"
        >
          Details
        </Link>
        {item.url && (
          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-primary dark:text-gray-400"
          >
            Visit site &rarr;
          </a>
        )}
      </div>
    </div>
  );
}
